export default class build_switcher {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        require("../swipehelper.js");

        this.btns = document.querySelectorAll(".build__switcher-btn");
        this.images = document.querySelectorAll(".build__switcher-img");
        this.names = document.querySelectorAll(".build__name-item");
        this.lines = document.querySelectorAll(".build__line");
        this.page = document.querySelector(".page");
        this.selected = 0;

        this.bindEvents();
        this.init();
    }
    init() {}
    bindEvents() {
        this.element.addEventListener("swiped-left", e =>
            this.showPreviousImage(e)
        );
        this.element.addEventListener("swiped-right", e =>
            this.showNextImage(e)
        );
        this.btns.forEach(btn => {
            btn.addEventListener("click", e => {
                if (btn.dataset.switch == "previous") {
                    this.showPreviousImage(e);
                } else if (btn.dataset.switch == "next") {
                    this.showNextImage(e);
                }
            });
        });
    }
    showPreviousImage(e) {
        this.images.forEach(image => {
            image.classList.remove("build__switcher-img--active");
        });
        this.lines.forEach(item => {
            item.classList.remove("build__line--active");
        });
        this.names.forEach(item => {
            item.classList.remove("build__name-item--active");
        });
        this.page.classList.add("noscroll");
        this.selected -= 1;

        if (this.selected < 0) {
            this.selected = this.images.length - 1;
        }
        this.images[this.selected].classList.add("build__switcher-img--active");
        this.lines[this.selected].classList.add("build__line--active");
        this.names[this.selected].classList.add("build__name-item--active");
        this.page.classList.remove("noscroll");
    }
    showNextImage() {
        this.images.forEach(image => {
            image.classList.remove("build__switcher-img--active");
        });
        this.lines.forEach(item => {
            item.classList.remove("build__line--active");
        });
        this.names.forEach(item => {
            item.classList.remove("build__name-item--active");
        });

        this.page.classList.add("noscroll");
        this.selected += 1;
        if (this.selected > this.images.length - 1) {
            this.selected = 0;
        }

        this.images[this.selected].classList.add("build__switcher-img--active");
        this.lines[this.selected].classList.add("build__line--active");
        this.names[this.selected].classList.add("build__name-item--active");
        this.page.classList.remove("noscroll");
    }
}
